/**
 * Who is calling. The backend keeps no cookie session: every caller carries a
 * bearer, either a Firebase ID token (web, mobile, staff, storefront guest) or a
 * Shopify App Bridge session token (POS, embedded admin).
 */
export interface ApiContext {
  readonly authToken?: string;
}

export const anonymous: ApiContext = {};

export function withToken(authToken: string): ApiContext {
  return { authToken };
}
